export default __webpack_public_path__ + "static/media/8.ce5f252a.jpg";